import { render } from "./TrainingForm.vue?vue&type=template&id=c3dfd4dc&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import "./TrainingForm.vue?vue&type=style&index=0&id=c3dfd4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3dfd4dc"]])

export default __exports__